export default __webpack_public_path__ + "static/media/wb.348ba606.webp";